<template>
    <div>
        <div>
            <div>
                <div class="search-bar">
                    <!-- <img src="@/assets/img/job-seeker/jam_search.svg" class="search-icon" height="20" alt="Search" /> -->
                    <el-input data-testid="directions-98" v-model="filter.text" class="job-board__search"
                        placeholder="Enter Job Title" clearable @input="debouncedUpdateLocalStorage" @clear="clearText">
                        <template #prefix>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
                                    stroke="#484848" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M22 22L20 20" stroke="#484848" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </template>
                    </el-input>
                    <button class="filter-button" data-testid="directions-99" @click="toggleFilterOptions">
                        <!-- <img v-if="isFilterOptionsVisible" src="@/assets/img/job-seeker/setting-active.svg" /> -->
                        <img src="@/assets/img/job-seeker/setting-inactive.svg" />
                        <span v-if="countFilters() > 0">{{ countFilters() }}</span>
                    </button>
                </div>

            </div>

            <!-- Search results -->
            <div v-if="initialIsLoading">
                <job-listing-skeleton :skeletonCount="7" />
            </div>
            <div class="search-results" v-else>
                <div class="job-results" v-if="jobs.length > 0">
                    <history-item-card :preJobs="jobs"></history-item-card>
                    <!-- Loading animation -->
                    <div v-if="isLoading" class="loading-animation">
                        <ion-spinner name="dots"></ion-spinner>
                    </div>
                </div>
                <div v-else>
                    <div class="search_jobs_header no-results-job-listing">
                        <img :src="require(`@/assets/img/illustrations/no-result.svg`)" alt="" />
                        <div class="main_title">No Applications Yet</div>
                        <div class="main_text">
                            You haven’t applied for any jobs yet. Start exploring opportunities and take the first step toward your next role!
                        </div>
                    </div>
                    <p class="no-results"></p>
                </div>

            </div>
            <div id="bottomHistoryObserver"></div>
        </div>
    </div>
    <el-drawer title="Job Filters" v-model="modalPreviousApplicationVisible" :close-on-click-modal="true"
        :destroy-on-close="true" @close="closeCreateWishlistModal" :append-to-body="true" :direction="'btt'">
        <Filter :modalPreviousApplicationVisible="modalPreviousApplicationVisible" @job-previous-application-filter="updateJobsWithFilters"
            @update:modalPreviousApplicationVisible="updateModalVisibility" />
    </el-drawer>
</template>

<script>
import { useStore } from "vuex";
// import {
//     useRouter,
// } from "vue-router";
import { onMounted, ref, inject, watch,onUnmounted } from 'vue';
import { addIcons } from 'ionicons';
import { arrowBackOutline } from 'ionicons/icons';
import { IonSpinner } from '@ionic/vue';
import HistoryItemCard from './Cards/HistoryItemCard.vue';
import JobListingSkeleton from "@/components/JobListingSkeleton/JobListingSkeleton.vue";
import debounce from 'lodash/debounce';
import Filter from './Filters/HistoryFilterPage.vue';
addIcons({
    'arrow-back-outline': arrowBackOutline,
});

export default {
    components: {
        HistoryItemCard,
        IonSpinner,
        JobListingSkeleton,
        Filter
    },
    props: {
        isActive: {
            type: Boolean,
            required: true
        }
    },
    setup() {
        const $store = useStore();
        // const $router = useRouter();
        const setPageClassGlobal = inject('setPageClassGlobal');
        // const tabHistoryClicked = ref(false);
        const initialIsLoading = ref(false);
        const jobs = ref([]);
        const currentPage = ref(1); // Track the current page
        const isLoading = ref(false); // Track if data is currently being loaded
        let observer = null;
        const modalPreviousApplicationVisible = ref(false);


        const filter = ref(JSON.parse(localStorage.getItem('jobSeekerFilterObject')) ? JSON.parse(localStorage.getItem('jobSeekerFilterObject')) : {
            text: '',
            jobType: '',
            jobLocation: '',
            taggedSkills: [],
        });

        const observeIntersection = () => {
            const handleIntersection = (entries) => {
                console.log("entries", entries);
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        loadMoreJobs();
                    }
                });
            };

            observer = new IntersectionObserver(handleIntersection, {
                root: null,
                rootMargin: '500px 0px',
                threshold: 0.1,
            });

            observer.observe(document.getElementById('bottomHistoryObserver'));
        };

        const unobserveIntersection = () => {
            if (observer) {
                observer.disconnect();
            }
        };
        const countFilters = () => {
            let count = 0;
            for (const key in filter.value) {
                const value = filter.value[key];
                if (value != null && value !== '' && !(Array.isArray(value) && value.length === 0)) {
                    if (typeof value === 'object' && Object.keys(value).length === 0) {
                        continue; // Skip empty objects
                    }
                    if (key === 'rate' && value.type === '') {
                        continue; // Skip empty rate object
                    }
                    count++;
                }
            }
            // Adjust count if text, jobType, and jobLocation are all empty
            // if (filter.value.text === '' && filter.value.jobType === '' && filter.value.jobLocation === '') {
            //     count--;
            // }
            return count;
        };
       

        const toggleFilterOptions = () => {
            modalPreviousApplicationVisible.value = true;
            // $router.push({
            //     name: "job_seeker_history_filter",// Assuming job object has an 'id' property
            // });
        };
        const updateModalVisibility = (value) => {
            modalPreviousApplicationVisible.value = value;
        };

        onMounted(() => {
            console.log("jjjj");
            setPageClassGlobal('global_job_seeker_history_page');
            observeIntersection();
            initialFetchJobData();
            observer.observe(document.getElementById('bottomHistoryObserver'));
        });

        onUnmounted(() => {
            unobserveIntersection();
        });

        // onBeforeMount(async () => {
        //     await initialFetchJobData();
        // });

        const updateJobsWithFilters = () => {
            filter.value = JSON.parse(localStorage.getItem('jobSeekerHistoryFilterObject')) ? JSON.parse(localStorage.getItem('jobSeekerHistoryFilterObject')) : {
            text: '',
            jobType: '',
            jobLocation: '',
            taggedSkills: [],
        };
            // countFilters();
            loadMoreJobs();
        }

        const initialFetchJobData = async () => {
            console.log('kkkkk')
            return new Promise((resolve) => {
                initialIsLoading.value = true;
                $store.dispatch("JOB_SEEKER_PREVIOUS_JOB_LIST", { page: currentPage.value, filter: filter.value })
                    .then((response) => {
                        let jobFetchResult = response.data;
                        console.log("🚀 ~ .then ~ jobFetchResult:", jobFetchResult)
                        const jobsData = jobFetchResult.map(job => ({
                            id: job.id,
                            title: job.jobPost.title,
                            poster: job.jobPost.pharmacy.name,
                            image: job.jobPost.pharmacy.image,
                            location: job.jobPost.location,
                            category: job.jobPost.category.category,
                            type: job.jobPost.type,
                            description: job.jobPost.description,
                            shortDescription: job.jobPost.shortDescription,
                            status: job.status,
                            applied: job.appliedAgo,
                            jobPharmacy: job.jobPost.pharmacy
                        }));
                        console.log("🚀 ~ jobsData23232323232 ~ jobsData:", jobsData)

                        // Assign the mapped data to the jobs ref variable
                        jobs.value = jobsData;
                        jobs.value.meta = response.meta;
                        initialIsLoading.value = false;
                        resolve(response);
                    });
            });
        };
        const loadMoreJobs = async () => {
            // Prevent loading more data if already loading or if reached last page
            console.log("🚀 ~ loadMoreJobs ~ isLoading:", jobs.value)
            if (isLoading.value || currentPage.value >= jobs.value.meta?.lastPage) return;
            console.log("🚀 ~ loadMoreJobs ~ currentPage:", currentPage)
            isLoading.value = true;
            try {
                const response = await $store.dispatch("JOB_SEEKER_PREVIOUS_JOB_LIST", { page: currentPage.value + 1, filter: filter.value });
                const newJobs = response.data.map(job => ({
                    id: job.id,
                    title: job.jobPost.title,
                    poster: job.jobPost.pharmacy.name,
                    image: job.jobPost.pharmacy.image,
                    location: job.jobPost.location,
                    category: job.jobPost.category.category,
                    type: job.jobPost.type,
                    description: job.jobPost.description,
                    shortDescription: job.jobPost.shortDescription,
                    status: job.status,
                    applied: job.appliedAgo,
                    jobPharmacy: job.jobPost.pharmacy
                }));
                jobs.value = [...jobs.value, ...newJobs];
                jobs.value.meta = response.meta;
                currentPage.value++;
            } catch (error) {
                console.error("Error loading more jobs:", error);
            } finally {
                isLoading.value = false;
            }

        };


        // Function to update localStorage
        const updateLocalStorage = () => {
            console.log("🚀 ~ updateLocalStorage ~ selectedValues.value", filter.value)
            localStorage.setItem('jobSeekerFilterObject', JSON.stringify(filter.value));
            currentPage.value = 1;
            initialFetchJobData();
        };
        const debouncedUpdateLocalStorage = debounce(updateLocalStorage, 500); // Adjust the debounce delay as needed
        // Watch for changes in filter and update localStorage accordingly
        watch(filter, () => {
            updateLocalStorage();

        });

        const clearText = () => {
            console.log('clear text')
            filter.value.text = '';
            currentPage.value = 1;
            debouncedUpdateLocalStorage();
            // Update local storage to remove only the 'text' property from 'jobSeekerFilterObject'
            const storedValues = JSON.parse(localStorage.getItem('jobSeekerFilterObject'));
            if (storedValues) {
                delete storedValues.text;
                localStorage.setItem('jobSeekerFilterObject', JSON.stringify(storedValues));
            }
            initialFetchJobData();
        };

        return {
            jobs,
            isLoading,
            filter,
            toggleFilterOptions,
            updateLocalStorage,
            clearText,
            initialIsLoading,
            debouncedUpdateLocalStorage,
            countFilters,
            modalPreviousApplicationVisible,
            updateModalVisibility,
            updateJobsWithFilters
        };
    },
};
</script>
